import router from './router'
import store from './store/index'
import { getToken } from '@/utils/auth'
import server from './utils/server'

//判断权限是否存在
function hasPermission(roles, permissionRoles){
	if(roles.indexOf('admin')>0) return true; //admin时直接通过
	if(!permissionRoles) return true; //
	return roles.some(role => permissionRoles.indexOf(role) >= 0);
}

//routerforEach()钩子函数
const whiteList = ['/login', '/form/test'] //白名单 不需要token 不需要登录
router.beforeEach((to, from, next)=>{
	var patharr = to.path.split('/');
	if(patharr[1].toLowerCase() == 'test-result'){
		next();
		return false;
	}

	// if(true){
	if(getToken()){ //判断是否存在token getToken()
		if(to.path==='/login'){
			next({ path: '/' })
			console.log("aa")
		}else{

			if(store.getters.roles.length === 0){ // 判断当前用户是否已拉取完user_info信息
				server.post("/User/GetCurrentUser").then(function(res){
					//next();
					var data = res.data.Data;
					var roles = data.PermissionList;
					store.dispatch('GenerateRoutes', { roles }).then(() => {
						router.addRoutes(store.getters.addRouters) // 动态添加可访问路由表
						   next({ ...to }) // hack方法 确保addRoutes已完成
					})

					// var userInfo = res.data.admin;
					if( !data.PermissionList || data.PermissionList.length==0 ){
						data.PermissionList = [];
						data.PermissionList.push("noPermission");
					}

					var userInfo = {
						...data,
						name: data.Name,
						role: data.PermissionList
					}
					store.dispatch('SetUserInfo', { userInfo }).then(()=>{
						console.log("设置用户信息成功...");
					})
			  }).catch(()=>{})

				// server.post("/GetUserInfo", { "user": "admin", "password": "123456" }).then(function(res){
				// 	console.log(res);
				// })

				// $.ajax({
				// 	// url: "http://localhost:54574/session",
				// 	// url: "http://localhost:54574/user/userinfo",
				// 	url: "http://localhost:54574/auth?formart=json",
				// 	// url: "http://localhost:54574/hello",
				// 	type: "post",
				// 	headers: {
				// 		// "Session": "admin",
				// 		"Accept": "application/json; charset=utf-8"
				// 	},
				// 	data: {
				// 		"UserName": "admin",
				// 		"Password": "123456"
				// 		// "CustomName": "admin"
				// 		// "Name": "Python"
				// 	},
				// 	dataType: "json",
				// 	success: function(data){
				// 		console.log(data);
				// 	}
				// })


		        // $.ajax({
		        // 	type:"get",
		        // 	url:"/static/data/user.json",
		        // 	async:true,
		        // 	success: function(data){
		        // 		var roles = data.admin.role;
			      //     	store.dispatch('GenerateRoutes', { roles }).then(() => {
						// 				// console.log(store.getters.addRouters, "xxx");
			      //     		router.addRoutes(store.getters.addRouters) // 动态添加可访问路由表
	          //   			next({ ...to }) // hack方法 确保addRoutes已完成
						// 				// console.log(router);
			      //     	})
						//
			      //     	var userInfo = data.admin;
			      //     	store.dispatch('SetUserInfo', { userInfo }).then(()=>{
			      //     		console.log("设置用户信息成功...");
			      //     	})
		        // 	}
		        // });


			}else{
				//已拉取客户信息，直接下一步
				next();
			}
		}
	}else{
		var patharr = to.path.split('/');
		console.log(patharr);

		if(whiteList.indexOf(to.path) != -1){
			next();//白名单直接进入
		}else if (patharr[1].toLowerCase() == 'card' && patharr[2].toLowerCase() == 'add') {
			next();
		} else if(patharr[1].toLowerCase() == 'card' && patharr[2].toLowerCase() == 'detail'){
			next();
		}
		else{
			next({ path: "/login"});
		}
	}
})



// WEBPACK FOOTER //
// ./src/permission.js